<template>
    <markets-ui-popover
        :class="namespace()"
        :customClass="customClass"
        :namespaced="namespaced"
        :visible="visible"
        :target="target"
        :width="width"
        :skin="skin"
    >
        {{ tipsMsg }}
    </markets-ui-popover>
</template>

<script>
import utils from '../../utils';
import mixins from '../mixins';
export default {
    name: 'markets-ui-tips',
    mixins: [mixins],
    props: {
        tipsMsg: {
            type: String,
            default: ''
        },
        visible: {
            type: Boolean,
            default: false
        },
        target: {
            required: true
        },
        width: {
            type: Number,
            default: 200
        },
        customClass: {
            type: String,
            default: ''
        }
    },
    created() {
        this.namespace = utils.namespace('ui-tips', false);
    }
};
</script>
